/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../Dashboard/Sidebar/Sidebar.css";
import { MdLaptopMac, MdOutlineEmail, MdOutlineScreenshotMonitor } from "react-icons/md";
// import SidebarImg from "../../../Assets/Images/profileimg.png";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { GoTasklist } from "react-icons/go";
import { HiArrowCircleDown } from "react-icons/hi";
import { HiOutlineLogout } from "react-icons/hi";
import { TbReportSearch } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { LuCoffee } from "react-icons/lu";
import { TbReport } from "react-icons/tb";
import {
  GetLoginRole,
  RemoveUserSession,
} from "../../../Utils/utils";
import { PiNotePencilBold } from "react-icons/pi";
import { PiNotebookBold } from "react-icons/pi";
import { IoMan } from "react-icons/io5";
import { AiOutlineProject } from "react-icons/ai";
import { useProfile } from "../../../Context/ProfileContext";
import dummyimage from "../../../Assets/Images/dummyimg.png";

const Sidebar = ({ showSidebar, dummy, setDummy }) => {
  const userRole = GetLoginRole("LoginRole");
  const { profileData } = useProfile();
  const [MobileView, setMobileView] = useState(true);
  const getUserRole = GetLoginRole();
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;
  // Admin sidebar
  const adminDashboardData = [
    {
      name: "Dashboard",
      icon: <MdLaptopMac className="sidebar-icon" />,
      route: "/Adm/Dashboard",
      subpages: [
        {
          name: "Add Announcement",
          route: "/Adm/Dashboard/AddAnnouncement",
        },
        {
          name: "Add Project Type",
          route: "/Adm/Dashboard/AddProjectType",
        },

        {
          name: "Add Departments",
          route: "/Adm/Dashboard/AdminDepartment",
        },
        {
          name: "Add Designation",
          route: "/Adm/Dashboard/AdminSubDepartment",
        }
      ],
    },
    {
      name: "Employees",
      icon: <IoMan className="sidebar-icon" />,
      // route: "/Adm/Employees/AllEmployees",
      subpages: [
        {
          name: "All Employees",
          route: "/Adm/Employees/AllEmployees",
        },
        {
          name: "Add Employees",
          route: "/Adm/Employees/AddEmployee",
        },
        {
          name: "My Profile",
          route: "/Adm/Employees/EmployeeProfile",
        },
        
      ],
    },
    {
      name: "Attendance",
      icon: <PiNotePencilBold className="sidebar-icon" />,
      // route: "/Adm/Attendance/TodaysAttendance",
      subpages: [
        {
          name: "Today’s Attendance",
          route: "/Adm/Attendance/TodaysAttendance",
        },
        {
          name: "Employee Attendance",
          route: "/Adm/Attendance/AttendanceSheet",
        },
        {
          name: "Import Excel",
          route: "/Adm/Attendance/ImportExcel",
        },
      ],
    },
    {
      name: "Leave Management",
      icon: <PiNotebookBold className="sidebar-icon" />,
      // route: "/Adm/LeaveManagement/AllLeaveRequests",
      subpages: [
        {
          name: "All Leave Requests",
          route: "/Adm/LeaveManagement/AllLeaveRequests",
        },
        {
          name: "Apply Leave",
          route: "/Adm/LeaveManagement/ApplyLeaves",
        },
        {
          name: "Employee Leave Approval",
          route: "/Emp/EMPLeavesApproval",
        },
        {
          name: "User Leave Report",
          route: "/Adm/LeaveManagement/UserReport",
        },

      ],
    },
    {
      name: "Holidays",
      icon: <LuCoffee className="sidebar-icon" />,
      // route: "/Adm/Holidays/AllHolidays",
      subpages: [
        {
          name: "All Holidays",
          route: "/Adm/Holidays/AllHolidays",
        },
        {
          name: "Add Holidays",
          route: "/Adm/Holidays/AddHolidays",
        },
      ],
    },
    // {F
    //   name: "Client",
    //   icon: <ImUser className="sidebar-icon" />,
    //   route: "/CreateClient",
    //   subpages: [
    //     {
    //       name: "Create",
    //       route: "/CreateClient",
    //     },
    //     {
    //       name: "View",
    //       route: "/AllClients",
    //     },


    //   ],

    // },

    // {
    //   name: "Tasks",
    //   icon: <GoTasklist className="sidebar-icon" />,
    //   route: "/TaskAssigned",
    //   subpages: [
    //     {
    //       name: "Assign Tasks",
    //       route: "/TaskAssigned",
    //     },
    //     {
    //       name: "Tasks In Progress" ,
    //       route: "/TasksInProgress",
    //     },
    //     {
    //       name: "View Tasks",
    //       route: "/ViewTask",
    //     }

    //   ],

    // },

    // {
    //   name: "Resume",
    //   icon: <HiArrowCircleDown className="sidebar-icon" />,
    //   route: "/Emp/ResumeUpload",
    //   subpages: [
    //     {
    //       name: "Resume Upload",
    //       route: "/Emp/ResumeUpload",
    //     },
    //     {
    //       name: "Resume Data" ,
    //       route: "/Emp/ResumeDisplay",
    //     },

    //   ],

    // },

    {
      name: "Recas",
      icon: <MdOutlineScreenshotMonitor className="sidebar-icon" />,
      route: "/Adm/RecasUserTable",
      // subpages: [
      //   {
      //     name: "Recas ",
      //     route: "/Adm/RecasUserTable",
      //   },
      //   {
      //     name: "Recas Screenshot" ,
      //     route: "/Adm/RecasScreenshot",
      //   },
      // ],
    },
    {
      name: "Daily Status Reports",
      icon: <TbReportSearch className="sidebar-icon" />,
      route: "/Adm/dailystatusreports",
    },

    // {
    //   name: "Profile",
    //   icon: <CgProfile className="sidebar-icon" />,
    //   route: "/Adm/Profile",
    // },
  ];
  // Employees Sidebar
  const employeeDashboardData = [
    {
      name: "Dashboard",
      icon: <MdLaptopMac className="sidebar-icon" />,
      route: "/Emp/Dashboard",
    },
    {
      name: "Attendance",
      icon: <PiNotePencilBold className="sidebar-icon" />,
      route: "/Emp/attendance",
    },
    {
      name: "Leave Management",
      icon: <AiOutlineProject className="sidebar-icon" />,
      // route: "/Emp/ApplyLeaves",
      subpages: [
        {
          name: "Apply Leaves",
          route: "/Emp/ApplyLeaves",
        },
        {
          name: "Leave Request",
          route: "/Emp/EMPLeaves",
        },
      ],
    },

    // {
    //   name: "Task",
    //   icon: <GoTasklist className="sidebar-icon" />,
    //   route: "/ViewTask",
    //     },

    {
      name: "Holidays",
      icon: <LuCoffee className="sidebar-icon" />,
      route: "/Emp/Holidays",
    },
    {
      name: "Daily Status Report",
      icon: <TbReport className="sidebar-icon" />,
      route: "/Emp/DailyStatusReport",
    },
    {
      name: "Assign Task Details",
      icon: <TbReport className="sidebar-icon" />,
      route: "/Emp/AssignTaskDetails",
    },

    // {
    //   name: "Resume",
    //   icon: <HiArrowCircleDown className="sidebar-icon" />,
    //   route: "/Emp/ResumeUpload",
    //   subpages: [
    //     {
    //       name: "Resume Upload",
    //       route: "/Emp/ResumeUpload",
    //     },
    //     {
    //       name: "Resume Data" ,
    //       route: "/Emp/ResumeDisplay",
    //     },

    //   ],

    // },
    // {
    //   name: "Profile",
    //   icon: <CgProfile className="sidebar-icon" />,
    //   route: "/Emp/Profile",
    // },
  ];
  // Team Lead Sidebar
  const teamLeadDashboardData = [
    {
      name: "Dashboard",
      icon: <MdLaptopMac className="sidebar-icon" />,
      route: "/Emp/Dashboard",
    },
    {
      name: "Attendance",
      icon: <PiNotePencilBold className="sidebar-icon" />,
      route: "/Emp/attendance",
    },
    {
      name: "Leave Management",
      icon: <AiOutlineProject className="sidebar-icon" />,
      // route: "/Emp/ApplyLeaves",
      subpages: [
        {
          name: "Apply Leaves",
          route: "/Emp/ApplyLeaves",
        },
        {
          name: "Leave Request",
          route: "/Emp/EMPLeaves",
        },
        // {
        //   name: "Leave Approval",
        //   route: "/Emp/EMPLeavesApproval",
        // },
        // {
        //   name: "Leave Report",
        //   route: "/Emp/EMPLeavesReports",
        // },

      ],
    },
    {
      name: "Holidays",
      icon: <LuCoffee className="sidebar-icon" />,
      route: "/Emp/Holidays",
    },
    {
      name: "Daily Status Report",
      icon: <TbReport className="sidebar-icon" />,
      route: "/Emp/DailyStatusReport",
    },
    // {
    //   name: "Tasks",
    //   icon: <GoTasklist className="sidebar-icon" />,
    //   route: "/TaskAssigned",
    //   subpages: [ 
    //     {
    //       name: "Assign Tasks",
    //       route: "/TaskAssigned",
    //     },
    //     {
    //       name: "Tasks In Progress" ,
    //       route: "/TasksInProgress",
    //     },
    //     {
    //       name: "View Tasks",
    //       route: "/ViewTask",
    //     }

    //   ],

    // },

    // {
    //   name: "Resume",
    //   icon: <HiArrowCircleDown className="sidebar-icon" />,
    //   route: "/Emp/ResumeUpload",
    //   subpages: [
    //     {
    //       name: "Resume Upload",
    //       route: "/Emp/ResumeUpload",
    //     },
    //     {
    //       name: "Resume Data" ,
    //       route: "/Emp/ResumeDisplay",
    //     },

    //   ],

    // },

    // {
    //   name: "Recas",
    //   icon: <MdOutlineScreenshotMonitor className="sidebar-icon" />,
    //   route: "/Adm/RecasUserTable",
    //   subpages: [
    //     {
    //       name: "Recas ",
    //       route: "/Adm/RecasUserTable",
    //     },
    //     {
    //       name: "Recas Screenshot" ,
    //       route: "/Adm/RecasScreenshot",
    //     },

    //   ],

    // },

    // {
    //   name: "Profile",
    //   icon: <CgProfile className="sidebar-icon" />,
    //   route: "/Emp/Profile",
    // },
  ];
  // HR Sidebar
  const hrDashboardData = [
    {
      name: "Dashboard",
      icon: <MdLaptopMac className="sidebar-icon" />,
      route: "/Emp/Dashboard",
      subpages: [
        {
          name: "Add Departments",
          route: "/Adm/Dashboard/AdminDepartment",
        },
        {
          name: "Add Project Type",
          route: "/Adm/Dashboard/AddProjectType",
        },
        {
          name: "Add Designation",
          route: "/Adm/Dashboard/AdminSubDepartment",
        },
        {
          name: "Add Announcement",
          route: "/Adm/Dashboard/AddAnnouncement",
        },
      ],
    },
    {
      name: "Attendance",
      icon: <PiNotePencilBold className="sidebar-icon" />,
      // route: "/Emp/attendance",
      subpages: [
        {
          name: "My Attendance",
          route: "/Emp/attendance",
        },
        {
          name: "Employee Attendance",
          route: "/Hr/Getattendance",
        },
        {
          name: "Import Excel",
          route: "/Hr/ImportExcel",
        },
      ],
    },
    {
      name: "Leave Management",
      icon: <AiOutlineProject className="sidebar-icon" />,
      // route: "/Emp/ApplyLeaves",
      subpages: [
        {
          name: "Apply Leaves",
          route: "/Emp/ApplyLeaves",
        },
        {
          name: "Leave Request",
          route: "/Emp/EMPLeaves",
        },
        {
          name: "Leave Approval",
          route: "/Emp/EMPLeavesApproval",
        },
        // {
        //   name: "Leave Report",
        //   route: "/Emp/EMPLeavesReports",
        // },
      ],
    },
     {
      name: "Employees",
      icon: <IoMan className="sidebar-icon" />,
      // route: "/Adm/Employees/AllEmployees",
      subpages: [
        {
          name: "All Employees",
          route: "/Adm/Employees/AllEmployees",
        },
        {
          name: "Add Employees",
          route: "/Adm/Employees/AddEmployee",
        },
        {
          name: "My Profile",
          route: "/Adm/Employees/EmployeeProfile",
        },
      ],
    },
    {
      name: "Holidays",
      icon: <LuCoffee className="sidebar-icon" />,
      // route: "/Adm/Holidays/AllHolidays",
      subpages: [
        {
          name: "All Holidays",
          route: "/Adm/Holidays/AllHolidays",
        },
        {
          name: "Add Holidays",
          route: "/Adm/Holidays/AddHolidays",
        },
      ],
    },

    // {
    //   name: "Tasks",
    //   icon: <GoTasklist className="sidebar-icon" />,  
    //   route: "/TaskAssigned",
    //   subpages: [
    //     {
    //       name: "Assign Tasks",
    //       route: "/TaskAssigned",
    //     },
    //     {
    //       name: "Tasks In Progress" ,
    //       route: "/TasksInProgress",
    //     },
    //     {
    //       name: "View Tasks",
    //       route: "/ViewTask",
    //     }

    //   ],

    // },


    // {
    //   name: "Jobs",
    //   icon: <HiOutlineDocumentArrowDown className="sidebar-icon" />,
    //   route: "/Emp/ResumeUpload",
    //   subpages: [
    //     {
    //       name: "Resume Upload",
    //       route: "/Emp/ResumeUpload",
    //     },
    //     {
    //       name: "Resume Data" ,
    //       route: "/Emp/ResumeDisplay",
    //     },

    //   ],

    // },

    {
      name: "Recas",
      icon: <MdOutlineScreenshotMonitor className="sidebar-icon" />,
      route: "/Adm/RecasUserTable",
      // subpages: [
      //   {
      //     name: "Recas ",
      //     route: "/Adm/RecasUserTable",
      //   },
      //   {
      //     name: "Recas Screenshot" ,
      //     route: "/Adm/RecasScreenshot",
      //   },

      // ],

    },
    {
      name: "Daily Status Report",
      icon: <TbReport className="sidebar-icon" />,
      route: "/Hr/DailyStatusReport",
    },

    // {
    //   name: "Profile",
    //   icon: <CgProfile className="sidebar-icon" />,
    //   route: "/Emp/Profile",
    // },
  ];
  const [showDashboards, setShowDashboards] = useState(
    adminDashboardData?.map(() => false)
  );
  const [showToggleSidebar, setShowToggleSidebar] = useState(
    adminDashboardData?.map(() => false)
  );
  const toggleDashboard = (index) => {
    const updatedDashboards = showDashboards?.map((value, i) =>
      i === index ? !value : value
    );
    setShowDashboards(updatedDashboards);
  };
  const toggelSidebar = (index) => {
    const updatedSidebar = showToggleSidebar.map((value, i) =>
      i === index ? !value : value
    );
    setShowToggleSidebar(updatedSidebar);
  };
  const handleLogout = () => {
    RemoveUserSession();
    navigate("/", { replace: true });;
  };
  const renderSubpages = (subpages) => (
    <ul>
      {subpages?.map((subpage, subIndex) => (
        <li key={subIndex}>
          <NavLink
            to={subpage?.route}
            className={({ isActive }) => (isActive ? "active-subpage" : "")}
          >
            {subpage?.name}
          </NavLink>
        </li>
      ))}
    </ul>
  );
  const renderDashboardData =
    getUserRole === "Admin"
      ? adminDashboardData
      : getUserRole === "TeamLead"
        ? teamLeadDashboardData
        : getUserRole === "HR" || getUserRole === "Manager"
          ? hrDashboardData
          : employeeDashboardData;

  useEffect(() => {
    const checkMobileView = () => {
      setMobileView(window.innerWidth <= 1100);
    };
    checkMobileView();
    window.addEventListener("resize", checkMobileView);
    return () => {
      window.removeEventListener("resize", checkMobileView);
    };
  }, []);
  const renderTooltiplogout = (props) => (
    <Tooltip id="button-tooltip-logout" {...props}>
      Logout
    </Tooltip>
  );
  useEffect(() => {
    const updatedDashboards = renderDashboardData.map((dashboard) =>
      dashboard?.subpages?.some((sub) => url.startsWith(sub.route))
    );

    setShowDashboards(updatedDashboards);
  }, [url]);

  return (
    <>
      {showSidebar ? (
        <>
          <div className="sidebar-main-container">
            <div className="siderbar-overflow-data-handle">
              <div className="siderbar-image-container">
                <div className="image-of-sidebar-in-dashboard">
                  {profileData?.UrlLink ? (
                    profileData?.UrlLink && (
                      <img
                        className="image-of-sidebar"
                        src={profileData.UrlLink}
                        alt={dummyimage}
                      />
                    )
                  ) : (
                    <CgProfile className="profile-icon-sidebar" />
                  )}
                </div>
                <p className="sidebar-Sarah">{profileData?.FirstName} {profileData?.LastName} </p>
                <p className="sider-bar-admin">
                  {userRole === "TeamLead" ? "Team Lead" : userRole}
                  {/* {profileData?.Designations?.DesignationName} */}
                </p>
              </div>
              <section className="sidebar-outter-container">
                <div className="Siderbar-inner-container">
                  {renderDashboardData?.map((dashboard, index) => (
                    <ul
                      key={index}
                      onClick={() => toggleDashboard(index)}
                      className="container-of-single-compomnent"
                    >
                      <li>
                        <Link
                          to={dashboard?.route || "#"}
                          className="links-main-pages"
                        >
                          <div
                            className={`setSiderbar ${dashboard?.route === url ||
                                dashboard?.subpages?.some((subpage) =>
                                  url.startsWith(subpage.route)
                                )
                                ? "active"
                                : ""
                              }`}
                          >
                            <div className="siderbar-all-data">
                              <div>
                                {dashboard.icon}
                                <span className="dashboard-name">
                                  {dashboard?.name}
                                </span>
                              </div>
                            </div>

                            <span className="Dashboard-icons">
                              {dashboard?.subpages &&
                                dashboard?.subpages?.length > 0 ? (
                                showDashboards[index] ? (
                                  <IoIosArrowDown />
                                ) : (
                                  <IoIosArrowForward />
                                )
                              ) : null}
                            </span>
                          </div>
                        </Link>
                      </li>
                      <li
                        className="siderbar-alldropdown"
                        onClick={() => toggelSidebar(index)}
                      >
                        {showDashboards[index] &&
                          renderSubpages(dashboard.subpages)}
                      </li>
                    </ul>
                  ))}
                  {MobileView && (
                    <div
                      className="mobile-view-data"
                      onClick={() => navigate("/ForgotPassword")}
                    >
                      <span>
                        <MdOutlineEmail className="navbar-icons-siderbar" />
                      </span>
                      <span className="text-on-dropdown-Siderbar">
                        Update Password
                      </span>
                    </div>
                  )}
                  {/* <div
                    className="logout-container-in-sidebar"
                    onClick={handleLogout}
                  >
                    <HiOutlineLogout className="sidebar-icon" />
                    <NavLink className="dashboard-name">Logout</NavLink>
                  </div> */}
                </div>
              </section>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="sidebar-main-container-new">
            <div className="siderbar-overflow-data-handle">
              <section className="sidebar-outter-container-new">
                <div className="Siderbar-inner-container">
                  {renderDashboardData?.map((dashboard, index) => (
                    <ul key={index}>
                      <li>
                        <Link to={dashboard?.route} className="links-main-pages">
                          <div
                            className={`sidebar-all-data-new ${dashboard.route === url ? "active" : ""
                              }`}
                          >
                            <OverlayTrigger
                              key={index}
                              placement="right"
                              delay={{ show: 250, hide: 400 }}
                              overlay={<Tooltip id={index}>{dashboard.name}</Tooltip>}
                            >
                              <div>{dashboard.icon}</div>
                            </OverlayTrigger>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  ))}
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltiplogout}
                  >
                    <div className="logout-toggle-function">
                      <HiOutlineLogout onClick={handleLogout} />
                    </div>
                  </OverlayTrigger>
                </div>
              </section>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Sidebar;
